import { BaseService } from '../base';
import type {
  DiretrixCaepfRequest,
  DiretrixCaepfResponse,
  DiretrixQuoteEngineDataRequest,
  DiretrixQuoteEngineDataResponse,
} from './types';

type ServiceResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
};

const BASE_URL = import.meta.env.VITE_API_URL;

export class ComplianceDiretrixService extends BaseService {
  async getQuoteEngineData(
    payload: DiretrixQuoteEngineDataRequest
  ): Promise<ServiceResponse<DiretrixQuoteEngineDataResponse>> {
    const response = await this.post(
      '/portal/v1/services/compliance/diretrix/quote-engine-data',
      payload,
      BASE_URL
    );

    return this.handleJsonResponse<DiretrixQuoteEngineDataResponse>(response);
  }

  async getCaepfData(
    payload: DiretrixCaepfRequest
  ): Promise<ServiceResponse<DiretrixCaepfResponse>> {
    const response = await this.post(
      '/portal/v1/services/compliance/diretrix/caepf',
      payload,
      BASE_URL
    );

    return this.handleJsonResponse<DiretrixCaepfResponse>(response);
  }
}

export const complianceDiretrixService = new ComplianceDiretrixService();

export type {
  DiretrixCaepfRequest,
  DiretrixCaepfResponse,
  DiretrixQuoteEngineDataRequest,
  DiretrixQuoteEngineDataResponse,
} from './types';
